<template>
  <tr>
    <td>
      {{ currencyExchangeRate.base }}
    </td>
    <td>
      {{ currencyExchangeRate.quote }}
    </td>
    <td>
      {{ currencyExchangeRate.rate }}
    </td>
    <td>
      {{ rate }}
    </td>
    <td>
      {{ currencyExchangeRate.date | moment('D MMM YYYY') }}
    </td>
  </tr>
</template>

<script>
  import Big from 'big.js'

  export default {
    name: 'CurrencyExchangeRateRow',
    props: {
      currencyExchangeRate: {
        type: Object,
        default: null
      },
      year: {
        type: Number,
        default: (new Date().getFullYear())
      },
      marginRates: {
        type: Array,
        default: () => ([])
      }
    },
    computed: {
      rate() {
        let currentYear = (new Date().getFullYear())

        let yearsInFuture = this.year - currentYear

        let margin = this.marginRates.find(r => r.years_in_future === yearsInFuture)

        if (!margin) margin = { rate: 0 }

        return Big(margin.rate).add(1).mul(this.currencyExchangeRate.rate).round(6).toString()
      }
    }
  }
</script>
